import React from "react";
import PropTypes from "prop-types";
import icons from '../../../assets/icons.svg'

const Icon = ({ name, className }) => {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={`svg svg-${name} ${className || ''}`}
        style={{ width: "16px", height: "16px"}}
    >
      <use xlinkHref={`${icons}#${name}`} />
    </svg>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default Icon;
